<template>
<div id="servicesCenters">
  <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en' ,'map-container']">
    <div class="inner-map">
      <div class="header-content">
        <div :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en', 'map-title my-2']">{{$t('serviceCenter.findUs')}}</div>
        <div class="map-desc">{{$t('serviceCenter.visit')}}</div>
      </div>
    </div>
  </div>
  <div class="main-content-container">
    <div class="search-bar-container">
      <div v-if="!loadOptions && !error" class="search-bar-content">
        <vue-simple-select class="city-selector"
                           :key="key"
                           v-model="selected"
                           :options="options"
        />
      </div>
    </div>
    <div style="padding: 2rem 0">
      <div v-if="loadData || loadOptions || error || errorData" style="height: 300px" class="response-handle">
        <Loader :class="loadOptions && ''"  v-if="(loadOptions && !loadData) || (loadData && !loadOptions)" />
        <Error v-if="error || errorData" />
      </div>
      <div v-for="(item, i) in data" :key="i" :class="[i !== data.length - 1 ? 'content-border' : '' ,'content']">
        <support-content :index="i" :type="type" :data="item"/>
      </div>
      <div v-if="data.length < totalElements && !loadOptions" @click="handleFetchMore" :class="[lang === 'ar' ? 'flex-row-reverse' : '', 'load-btn']">
        <div v-if="loading" class="spinner-border text-dark" role="status"></div>
        <div v-if="!loading" :class="[lang ==='ar' ? 'bold-italic-ar' : 'bold-italic-en','px-1']"> {{$t('serviceCenter.btn')}} </div>
        <div v-if="!loading" class="px-1"> <img class="btn-arrows" src="../../assets/icons/down-arrow.svg"></div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SupportContent from './SupportContent'
import VueSimpleSelect from 'vue-simple-custom-select'
import $ from 'jquery'
import CityCentersRepository from '../../repositories/CityCentersRepository'
import ServiceCentersRepository from '../../repositories/ServiceCentersRepository'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
export default {
  name: 'ServicesCenters',
  components: { SupportContent, VueSimpleSelect, Error, Loader },
  data () {
    return {
      lang: this.$lang,
      citiesRepo: new CityCentersRepository(),
      serviceCenterRepo: new ServiceCentersRepository(),
      key: 0,
      data: [],
      type: 'service-center',
      selected: { label: '', value: '' },
      options: [],
      page: 0,
      size: 4,
      loading: false,
      totalElements: 0,
      loadOptions: false,
      loadData: false,
      error: false,
      errorData: false,
      temp: []
    }
  },
  watch: {
    async selected (val) {
      this.options = []
      this.options = [...this.temp]
      this.data = []
      this.totalElements = 0
      this.loading = false
      this.page = 0
      this.options = this.options.filter(item => {
        return item.label !== this.selected.label
      })
      this.loadData = true
      try {
        const response = await this.serviceCenterRepo.getParamsById(val.value, this.page, this.size)
        if (response.status === 200) {
          this.totalElements = response.data.totalElements
          for (let i = 0; i < response.data.data.length; i++) {
            const temp = []
            for (let j = 0; j < response.data.data[i].services.length; j++) {
              temp.push({ title: response.data.data[i].services[j].name, desc: response.data.data[i].services[j].work })
            }
            this.data.push({
              address: response.data.data[i].address,
              days: response.data.data[i].holiday,
              title: val.label,
              info: [...temp],
              long: response.data.data[i].longitude,
              lat: response.data.data[i].latitude
            })
          }
        } else {
          this.errorData = true
        }
      } catch (e) {
        this.errorData = true
        return e
      }
      this.loadData = false
    }
  },
  created () {
    this.handleCities()
  },
  mounted () {
    setTimeout(() => {
      this.$lang === 'ar' ? $('.v-slide-group__content').addClass('regular-ar') : $('.v-slide-group__content').addClass('regular-en')
      this.$lang === 'ar' ? $('.vue-simple-select-container .vue-simple-select-button').addClass('flex-row-reverse') : $('.vue-simple-select-container .vue-simple-select-button').css('flex-direction', 'row')
      this.$lang === 'ar' ? $('svg.w-6.h-6.vue-simple-select-icon').css({ 'margin-left': 0, 'margin-right': 'auto' }) : $('svg.w-6.h-6.vue-simple-select-icon').css({ 'margin-left': 'auto', 'margin-right': 0 })
    })
  },
  methods: {
    async handleCities () {
      this.loadOptions = true
      try {
        const response = await this.citiesRepo.get()
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            this.options.push({ label: response.data[i].name, value: response.data[i].id })
          }
          this.temp = [...this.options]
          this.selected = {}
          for (let i = 0; i < this.options.length; i++) {
            if (this.options[i].label.slice(0, 3) === 'dam' || this.options[i].label.slice(0, 3) === 'Dam' || this.options[i].label.slice(0, 3) === 'دمش') { // make damascus the default selected city
              this.selected = { label: response.data[i].name, value: response.data[i].id }
            }
          }
          setTimeout(() => {
            this.key++
            setTimeout(() => {
              this.$lang === 'ar' && $('.vue-simple-select-container .vue-simple-select-button').addClass('flex-row-reverse') && $('svg.w-6.h-6.vue-simple-select-icon').css({ 'margin-left': 0, 'margin-right': 'auto' })
            })
          })
        } else {
          this.loadOptions = false
          this.error = true
        }
      } catch (e) {
        this.loadOptions = false
        this.error = true
        return e
      }
      this.loadOptions = false
    },
    async handleFetchMore () {
      this.page += 1
      this.loading = true
      try {
        const response = await this.serviceCenterRepo.getParamsById(this.selected.value, this.page, this.size)
        if (response.status === 200) {
          for (let i = 0; i < response.data.data.length; i++) {
            const temp = []
            for (let j = 0; j < response.data.data[i].services.length; j++) {
              temp.push({ title: response.data.data[i].services[j].name, desc: response.data.data[i].services[j].work })
            }
            this.data.push({ address: response.data.data[i].address, days: response.data.data[i].holiday, title: this.selected.label, info: [...temp] })
          }
        }
        this.loading = false
      } catch (e) {
        this.loading = false
        return e
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main.sass";
#servicesCenters{
  min-height: calc(100vh - (160px + 285.6px));
  background: rgba(242,242,242,.9);
  backdrop-filter: blur(25px);
}
.loader,
.error-container{
  min-height: calc(100vh - (170px + 225px + 285.6px)) !important;
}
.map-container{
  width: 100%;
  height: 225px;
  background-image: url("../../assets/images/map.png") ;
  position: relative;
}
.inner-map{
  width: 100%;
  height: 100%;
  backdrop-filter: blur(10px);
  position: absolute;
}
.header-content{
  height: 135px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.map-title{
  font-size: 25px;
  color: $--yellow;
}
.map-desc{
  font-size: 14px;
}
.main-content-container{
  //padding: 2rem 0;
  background: linear-gradient(to bottom, rgba(242,242,242, 0.85), rgba(255,255,255, 0.85));
  backdrop-filter: blur(25px);
  min-height: calc(100vh + 90px - (225px + 160px + 285px));
  border-top: 2px solid rgba(255,255,255, .8);
  border-radius: 30px 30px 0 0;
  margin-top: -90px
}.search-bar-container{
   width: 100%;
   height: 90px;
   //background: rgba(242,242,242);
   //backdrop-filter: blur(25px);
   display: flex;
   align-items: center;
   justify-content: center;
 }
.search-bar-content {
  height: 100%;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid rgba(255,255,255, .8);
}

.content{
  width: 70%;
  margin: 0 auto;
  //padding: 0 30px 5px 30px ;
}
.content-border{
  border-bottom: 1.5px solid $--yellow ;
}
@media (max-width: 900px) {
  .search-bar{
    width: 80%;
  }
  .content{
    width: 95% !important;
  }
}
@media (max-width: 550px) {
  .search-bar{
    width: 100%;
  }
  .content{
    width: 95% !important;
  }
}
</style>
<style lang="scss">
@import "src/assets/sass/main";
#servicesCenters{
  .vue-simple-select-container .vue-simple-select-dropdown{
    top: 112% !important;
    z-index: 100;
  }
  .vue-simple-select-container.city-selector{
    width: 35% !important;
    height: 50px;
    border: 3px solid #FFCB05;
    border-radius: 12px;
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    span.vue-simple-select-selected-option{
      color: $--black-dialog-text !important;
      font-family: Mtn-arabic-regular;
    }
  }
  @media (max-width: 1000px) {
    .vue-simple-select-container.city-selector {
      width: 50% !important;
    }
  }
  @media (max-width: 600px) {
    .vue-simple-select-container.city-selector {
      width: 70% !important;
    }
  }
  @media (max-width: 400px) {
    .vue-simple-select-container.city-selector {
      width: 80% !important;
    }
  }
}
</style>
<style scoped>
@media (max-width: 1000px) {
  #servicesCenters
  {
    min-height: calc(100vh - (170px + 392.2px));
  }
  .loader,
  .error-container{
    min-height: calc(100vh - (170px + 225px + 392.2px)) !important;
  }
}
@media (max-width: 575px) {
  #servicesCenters{
    min-height: calc(100vh - (170px + 814.6px));
  }
  .loader,
  .error-container{
    min-height: calc(100vh - (170px + 225px + 814.6px)) !important;
  }
}
</style>
